function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 10"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 24H1a1 1 0 01-1-1V12a12 12 0 1112 12zM2 22h10A10 10 0 102 12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.001 15.5l-.045-.001a1 1 0 01-.955-1.043l.018-.395a3.073 3.073 0 01.914-2.165l1.481-1.482a2 2 0 000-2.828 2.047 2.047 0 00-2.828 0A1.986 1.986 0 0010 9a1 1 0 01-2 0 3.973 3.973 0 011.172-2.828 4.094 4.094 0 015.656 0 3.999 3.999 0 010 5.656l-1.481 1.483a1.116 1.116 0 00-.33.793l-.018.44a1 1 0 01-.998.956z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "18",
  r: "1"
})));